import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TimeStatsParams {
  custMode?: any;
  cust?: string;
  proj?: string;
  act?: string;
  per?: string;
  type?: string;
  from: string;
  to: string;
}

export interface TimeStatsItem {
  year: number;
  month: number;
  timpris: number;
  timpris_utan_noll: number;
  debit: number;
  tot: number;
  oh: number;
  tjl: number;
  semester: number;
  idle: number;
  int_komp: number;
  int_proj: number;
  sjuk: number;
  hours?: number;
  intakt?: number;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class TimeStatsService {
  private apiUrl = '/api/timestatistics'; // Note: Angular proxy likely handles /api, usually it's just 'api/...' if base href is set, but sticking to pattern.

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(params: TimeStatsParams): Observable<TimeStatsItem[]> {
    // Legacy: "api/timestatistics/:from/:to"
    // But $resource also handles query params.
    // Let's check restServices.js again.
    // .factory("TimeStats", function ($resource) {
    //     return $resource(
    //       "api/timestatistics/:from/:to",
    // ...
    // It consumes from and to in path.
    // And other params (custMode, cust, proj, act, per, type) as query params?
    // Actually $resource will put unused params in query string.

    const url = `api/timestatistics/${params.from}/${params.to}`;
    let httpParams = new HttpParams();

    if (params.custMode) {
      httpParams = httpParams.append('custMode', JSON.stringify(params.custMode));
    }
    if (params.cust) httpParams = httpParams.append('cust', params.cust);
    if (params.proj) httpParams = httpParams.append('proj', params.proj);
    if (params.act) httpParams = httpParams.append('act', params.act);
    if (params.per) httpParams = httpParams.append('per', params.per);
    if (params.type) httpParams = httpParams.append('type', params.type);

    return this.http.get<TimeStatsItem[]>(url, { params: httpParams });
  }
}
